/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2023-01-09 19:50:53
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2023-02-24 23:20:34
 * @FilePath: /wemeet-web-activity/src/components/Coupon/couponBtn.tsx
 * @Description: 领券按钮
 */
import React, { memo, useContext } from 'react';
import { message } from '@tencent/tea-component';
import useReceiveCoupon from "./useReceiveCoupon";
import { ThemeContext } from "../BuyModal/context";
const CouponBtn = ({
  goToUse,
  coupon,
  disabled,
  onClick
}) => {
  const {
    http
  } = useContext(ThemeContext);
  const {
    isLoading,
    receiveCoupon
  } = useReceiveCoupon(http, coupon);
  if (coupon?.user_coupon_state === 2) {
    return /*#__PURE__*/React.createElement("a", {
      onClick: () => onClick?.(0),
      role: "button",
      className: "flag-btn"
    }, "\u5DF2\u4F7F\u7528");
  }
  return coupon?.user_coupon_state !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    onClick: () => {
      onClick?.(2);
      if (disabled) return;
      goToUse?.();
    },
    role: "button",
    className: "flag-btn flag-go-used"
  }, "\u53BB\u4F7F\u7528"), /*#__PURE__*/React.createElement("div", {
    className: "has-used-outer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "has-used"
  }, /*#__PURE__*/React.createElement("div", {
    className: "has-used-inner"
  }, "\u5DF2\u9886")))) : /*#__PURE__*/React.createElement("a", {
    onClick: () => {
      onClick?.(1);
      if (disabled) return;
      receiveCoupon().then(res => {
        res && message.success({
          content: '领券成功,快去用券购买吧',
          className: 'is-theme-dark is-align-middle'
        });
      });
    },
    role: "button",
    className: "flag-btn"
  }, isLoading ? '领取中' : '领取');
};
export default /*#__PURE__*/memo(CouponBtn);